export default "__VITE_PUBLIC_ASSET__3495a22f__"